import React, { useState } from 'react';
import { IconAdvisor, IconDoc } from './icons';
import { PerfilCaso } from './PerfilCaso';
import screens from '../datos/journey1.json';

const ETIQUETA = {};
screens.forEach((sc) => (sc.tiles || []).forEach((t) => { ETIQUETA[t.v] = t.t; }));
const et = (v) => String(v).split(', ').map((x) => ETIQUETA[x] || x).join(', ');

// Vista del cliente (punto 17): mensaje llano + canal y hora + lo que nos contó.
// envios (caso A): documentos que el asesor manda por WhatsApp al confirmar el valor asegurado.
export const AdvisorPanel = ({ data, canal, lead, usted = false, envios = null }) => {
  const [enviado, setEnviado] = useState(false);
  if (!data) return null;
  const hasLead = lead && (lead.momento || lead.nombre);
  const repites = usted ? 'No repite nada' : 'No repites nada';
  const canalPend = usted ? 'por definir con usted' : 'por definir contigo';
  return (
    <section className="advisor" data-testid="advisor-panel">
      <header className="advisor-head">
        <IconAdvisor size={22} color="#2F6B4F" />
        <div>
          <strong>Aquí entra un humano</strong>
          <span>{usted ? 'Esto es lo que recibe su asesor' : 'Esto es lo que recibe tu asesor'}</span>
        </div>
      </header>
      <p className="advisor-resumen" data-testid="advisor-resumen">
        {usted
          ? `Su momento, lo que quiere cuidar, lo que ya paga y lo que acordamos. ${repites}.`
          : `Tu momento, lo que quieres cuidar, lo que ya pagas y lo que acordamos. ${repites}.`}
      </p>
      <dl className="advisor-grid">
        <div className="advisor-row">
          <dt>Canal y hora</dt>
          <dd>
            <span className={`advisor-canal ${canal ? 'ok' : 'pendiente'}`} data-testid="advisor-canal">{canal || canalPend}</span>
          </dd>
        </div>
      </dl>
      <PerfilCaso perfil={lead && lead.perfil} />
      {hasLead ? (
        <div className="advisor-lead" data-testid="advisor-lead">
          <span className="advisor-lead-k">{usted ? 'Lo que nos contó' : 'Lo que nos contaste'}</span>
          <p>
            {[lead.nombre, lead.tel, lead.momento && String(lead.momento).replace(/^D\d\s*·\s*/, ''), (lead.cuidar || []).map(et).join(', '), lead.quienes && et(lead.quienes), lead.yapaga]
              .filter(Boolean)
              .join(' · ')}
            {lead.consent ? ' · autorización con fecha' : ''}
          </p>
        </div>
      ) : null}
      {envios ? (
        <div className="advisor-envios" data-testid="advisor-envios">
          <span className="advisor-lead-k">Lo que le envías al cliente por WhatsApp cuando confirmes el valor asegurado</span>
          <div className="cierre-docs">
            {envios.docs.map(([t, fn, tid]) => (
              <button key={tid} type="button" className="btn-doc" onClick={fn} data-testid={tid}>
                <IconDoc size={15} /> {t}
              </button>
            ))}
          </div>
          <button type="button" className="btn-accion advisor-enviar" disabled={enviado} onClick={() => setEnviado(true)} data-testid="advisor-enviar">
            {enviado ? `Enviado${lead && lead.tel ? ` al ${lead.tel}` : ''}` : 'Enviar'}
          </button>
        </div>
      ) : null}
    </section>
  );
};
